import React from "react";
import { Link } from "react-router-dom";

const Welcome = () => {
  return (
    <div>
      <h1>Welcome to Crucible</h1>

      <p>
        There is a child. He’s a homely boy, perhaps eight years old, and begging for change. Or food. Or simply a warm bed and a roof to protect him from the rain that’s currently beating down along the brick-and-mud street on which he stands. There’s a certain set to his jaw, a certain pallor to his skin that suggests something not entirely human in his family tree. Most of the people give him a wide berth. No one wants to make eye contact with the hopeless, after all. There are just too many refugees these days, they say to themselves. And who really has food to spare anymore?

</p>
      <p>
        Welcome to the world of Crucible. The Synod teaches us that there is but one god, the <Link to="/worldSmith">Worldsmith</Link>, and They have created this world to forge it's people's souls into more perfect beings. It is by overcoming the peril and dangers of the world that one becomes purer, stronger. Just as a blacksmith's crucible burns away the impurities of metal, so does the world of Crucible burn away the impurities of the soul.

</p>
      <p>
        If this is true, it seems like the the Worldsmith's forge is getting hotter, the perils greater.

</p>
      <p>
        Hundreds of years ago, the human empire of Esath grew to overtake the known world, and humans in their hubris thought it would last forever. The collapse happened slowly at first, then all at once. Sure, a few of the outlying provinces declared independence, and the armies had to be supplanted with mercenaries, but to the common man the Empire seemed mostly stable, it's fall inconceivable.
        And then, in the great orcish sacking of the capital, the center of the empire disintegrated. The outlying provinces found themselves to be suddenly independent city-states, and that instability beget more wars between the new proto-nations. The humans fought each other, weakening themselves all the while the monstrous races grew stronger.

</p>
      <p>
        Now the elves have retreated deep into their woods, the dwarves into their mountain homes. The humans have built their walls ever higher and stronger as the outlying towns slowly fall one after the other to orcs, goblins, and who knows what other monsters that roam the world.

</p>
      <p>
        Each year, another village is sacked and burned. In the military, talk is not of how to defeat the invaders, but how to staunch the bleeding. Reinforce the line here, pull the troops back there. They see no way to win, so they try to lose as slowly as possible, and hope for a miracle. And even in the face of annihilation, the city-states bicker and argue, their noble courts a den of vipers and backstabbing. Does humanity even deserve to survive?

</p>
      <p>
        The darkness is closing in. The people brace for the end with grim determination, knowing it’s only a matter of time before the orcs have finished with all the farming villages. In the taverns, bets are placed with gallows-humor laughs on whether they will breach the walls, come by river, or starve them to death with a siege.

</p>
      <p>
        This is how the story ends. Or is it? In the city of Blackport the sun is setting, and the child has given up on finding a meal today. As he picks himself up off the cobblestone, a stranger tosses him a few coins. It's not much, but it'll buy some food in the soup kitchen. And suddenly, the boy has something he didn't have before: hope.

</p>

    </div>
  );
};

export default Welcome;
